const Q = require('Q');
const CATEGORIES = require('../enums/review-category-enum');

function ReviewsByStore(ReviewService, $state, $stateParams) {
	this.reviewService = ReviewService;
	this.$state = $state;
	this.$stateParams = $stateParams;
}

ReviewsByStore.prototype.get = function (request, options) {
	const deferred = Q.defer();
	const model = {};
	model.category = CATEGORIES.STORE.DISPLAY;
	model.returnHref = this.$state.href(CATEGORIES.STORE.DISPLAY.URL, this.$stateParams);
	model.viewMoreHref = this.$state.href(`${CATEGORIES.STORE.DISPLAY.URL}.reviews`, this.$stateParams);

	this.reviewService.getByStoreId(request, options).then((productReview) => {
		model.overall = productReview.overall;
		model.reviews = productReview.reviews;
		deferred.resolve(model);
	});

	return deferred.promise;
};

module.exports = ReviewsByStore;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/factory/reviews-by-store.js
 **/